/**
 * LDM · Movimiento
 * ---------------------------------------------------------------------------
 * Entradas al hacer scroll y micro-interacciones.
 *
 * Corrige el defecto de la versión anterior: los elementos se mostraban desde el
 * principio y la animación se disparaba al cruzarlos, así que en lugar de entrar
 * parecían sacudirse. Ahora se ocultan antes de pintar y se revelan al asomar,
 * que es lo que hace que se lea como entrada.
 *
 * El ocultado inicial lo aplica el CSS, pero solo bajo la clase `ldm-js` que
 * marca este archivo al ejecutarse. Si el JavaScript falla o no llega, esa clase
 * nunca aparece y la página se ve completa: nada queda invisible por accidente.
 *
 * Las curvas y tiempos siguen el criterio de Motion (motion.dev), sobre la Web
 * Animations API nativa para no cargar la librería:
 *   - Salida suave: cubic-bezier(0.16, 1, 0.3, 1) — arranca y frena despacio.
 *   - Resorte: cubic-bezier(0.34, 1.56, 0.64, 1) — sobrepasa y vuelve.
 */
(function () {
  'use strict';

  var SIN_MOVIMIENTO =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SUAVE = 'cubic-bezier(0.16, 1, 0.3, 1)';
  var RESORTE = 'cubic-bezier(0.34, 1.56, 0.64, 1)';

  var SELECTORES = [
    '.ldm-section [class$="__kicker"]',
    '.ldm-section [class$="__title"]',
    '.ldm-section [class$="__subtitle"]',
    '.ldm-ben__card',
    '.ldm-ing__card',
    '.ldm-mb__item',
    '.ldm-ht__step',
    '.ldm-ba__card',
    '.ldm-rf__seal',
    '.ldm-faq__item',
    '.ldm-social__emblem',
    '.ldm-lead__text',
    '.ldm-cta-mid__btn',
    '.ldm-tst__viewport'
  ].join(',');

  /* Marca el documento antes del primer pintado para que el CSS pueda ocultar
     los elementos que se van a animar. Si este archivo no corre, la clase no se
     añade y todo queda visible. */
  document.documentElement.classList.add('ldm-js');

  /* Un elemento dentro de un carril horizontal puede no cruzar nunca la pantalla:
     está desplazado a la derecha, no hacia abajo. Si se dejara al observador,
     quedaría oculto para siempre y el carrusel mostraría tarjetas en blanco.
     Se detecta el caso y se revela sin esperar. */
  function enCarrilHorizontal(el) {
    var n = el.parentElement;
    while (n && n !== document.body) {
      var desborde = getComputedStyle(n).overflowX;
      if (desborde === 'auto' || desborde === 'scroll') return true;
      n = n.parentElement;
    }
    return false;
  }

  function revelar() {
    var nodos = Array.prototype.slice.call(document.querySelectorAll(SELECTORES));
    if (!nodos.length) return;

    nodos.forEach(function (el) {
      if (!el.hasAttribute('data-ldm-reveal')) el.setAttribute('data-ldm-reveal', '');
    });

    /* Lo que ya está en pantalla al cargar no debe animarse: el usuario no lo
       vio aparecer, lo encontró ahí. Se revela sin transición. */
    var alto = window.innerHeight;
    nodos.forEach(function (el) {
      if (el.getBoundingClientRect().top < alto * 0.9 || enCarrilHorizontal(el)) {
        el.setAttribute('data-ldm-reveal', 'visible');
      }
    });

    var pendientes = nodos.filter(function (el) {
      return el.getAttribute('data-ldm-reveal') !== 'visible';
    });
    if (!pendientes.length) return;

    var observador = new IntersectionObserver(
      function (entradas) {
        var entrando = entradas.filter(function (e) {
          return e.isIntersecting && e.target.getAttribute('data-ldm-reveal') !== 'visible';
        });

        entrando.forEach(function (entrada, i) {
          var el = entrada.target;
          el.setAttribute('data-ldm-reveal', 'visible');

          el.animate(
            [
              { opacity: 0, transform: 'translateY(14px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ],
            {
              duration: 640,
              // Escalonado corto entre hermanos: la rejilla se abre en cascada
              // en vez de aparecer entera de golpe.
              delay: Math.min(i * 70, 280),
              easing: SUAVE,
              fill: 'both'
            }
          );

          observador.unobserve(el);
        });
      },
      // Se dispara un poco antes de que el elemento toque el borde inferior,
      // para que la entrada termine cuando el usuario ya lo está mirando.
      { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
    );

    pendientes.forEach(function (el) {
      observador.observe(el);
    });
  }

  function pulsoDeTiers() {
    document.addEventListener('ldm:tier-change', function () {
      var sel = document.querySelector('[data-ldm-tier].is-selected');
      if (!sel) return;
      sel.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.012)' }, { transform: 'scale(1)' }],
        { duration: 280, easing: RESORTE }
      );
    });
  }

  function respuestaAlPulsar() {
    var botones = document.querySelectorAll(
      '.ldm-qo__cta, .ldm-cta-mid__btn, .ldm-sticky__cta, .ldm-sticky__step'
    );
    Array.prototype.forEach.call(botones, function (b) {
      b.addEventListener('pointerdown', function () {
        b.style.transform = 'scale(0.985)';
      });
      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) {
        b.addEventListener(ev, function () {
          b.style.transform = '';
        });
      });
    });
  }

  function init() {
    if (document.body.dataset.ldmMotion === 'true') return;
    document.body.dataset.ldmMotion = 'true';

    if (SIN_MOVIMIENTO) {
      // Sin animación, pero todo visible.
      document.documentElement.classList.remove('ldm-js');
      return;
    }

    revelar();
    pulsoDeTiers();
    respuestaAlPulsar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    document.body.dataset.ldmMotion = '';
    init();
  });
})();
